import { getPayerBaseUrl } from './URLBuilder';

/**
 * Every tag resolves to a template (Charles, 2026-10-06): modern tags carry
 * templateTagId; legacy tags carry it only as the prefix of their id, which
 * is minted as `${templateTagId}---${tagUid}`. A tag with neither is an
 * anomaly, not a branch to design around — callers just get null.
 */
export function templateTagIdOf(tag) {
  if (!tag) return null;
  if (tag.templateTagId) return String(tag.templateTagId);
  const id = typeof tag.id === 'string' ? tag.id : '';
  return id.includes('---') ? (id.split('---')[0] || null) : null;
}

/**
 * The template's sign-up (hero) image, served by strike-payer as a redirect
 * (GET /templates/:templateId/signup-image — 302 to the image, 404 when the
 * template has none). Reading it from the template, not from the tag's
 * one-shot actionText copy, keeps a re-uploaded image current on every
 * surface with no backfill.
 */
export function templateSignupImageUrl(tag) {
  const templateTagId = templateTagIdOf(tag);
  return templateTagId
    ? `${getPayerBaseUrl()}/templates/${encodeURIComponent(templateTagId)}/signup-image`
    : null;
}
